import { Deserializable } from '../deserializable';
import {ModulePermission} from './modulepermission';
export  class Module implements Deserializable
{
  public id: number;
  public code: string;
  public name: string;
  public description: string;
  public modulePermissionList: ModulePermission[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.modulePermissionList = input.modulePermissionList != null ? input.modulePermissionList.map(modulePermissionList => new ModulePermission().deserialize(modulePermissionList)): [];
    return this;
  }
}
